const CheckBrowser = () => {
    const body = document.querySelector("body");
    const isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
    const isChrome =
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor);
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (isFirefox) {
        body.classList.add("is-firefox");
    }
    if (isChrome) {
        body.classList.add("is-chrome");
    }
    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1) {
        body.classList.add("is-ie");
    }
    if (isIOS) {
        body.classList.add("is-ios");
    }
};

export default CheckBrowser;
